import { render, staticRenderFns } from "./CohortViewUserInfoCard.vue?vue&type=template&id=958c8906&scoped=true&"
import script from "./CohortViewUserInfoCard.vue?vue&type=script&lang=js&"
export * from "./CohortViewUserInfoCard.vue?vue&type=script&lang=js&"
import style0 from "./CohortViewUserInfoCard.vue?vue&type=style&index=0&id=958c8906&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "958c8906",
  null
  
)

export default component.exports